import axios from 'axios';
import { auth } from '../firebase';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { 'Content-Type': 'application/json' },
});

// প্রতিটা request এ auto Firebase token attach করো
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Admin API
export const getAccount       = ()           => api.get('/accounts');
export const getSpending      = (preset)     => api.get(`/accounts/spending?date_preset=${preset}`);
export const getClients       = ()           => api.get('/clients');
export const getClient        = (id)         => api.get(`/clients/${id}`);
export const createClient     = (data)       => api.post('/clients', data);
export const updateClient     = (id, data)   => api.put(`/clients/${id}`, data);
export const deleteClient     = (id)         => api.delete(`/clients/${id}`);
export const getClientCamps   = (id)         => api.get(`/clients/${id}/campaigns`);
export const getClientSpend   = (id, preset) => api.get(`/clients/${id}/spending?date_preset=${preset}`);
export const optimizeClient   = (id, apply)  => api.post(`/clients/${id}/optimize`, { apply });
export const getCampaigns     = (status)     => api.get(`/campaigns${status ? `?status=${status}` : ''}`);
export const getAllInsights    = (preset)     => api.get(`/campaigns/all-insights?date_preset=${preset}`);
export const pauseCampaign    = (id)         => api.put(`/campaigns/${id}/pause`);
export const resumeCampaign   = (id)         => api.put(`/campaigns/${id}/resume`);
export const getWeeklyReport  = ()           => api.get('/reports/weekly');
export const getSpendReport   = (preset)     => api.get(`/reports/spending?date_preset=${preset}`);
export const getLeads         = (params)     => api.get('/leads', { params });
export const addLead          = (data)       => api.post('/leads', data);
export const followUpLead     = (id, msg)    => api.post(`/leads/${id}/followup`, { message: msg });
export const convertLead      = (id)         => api.put(`/leads/${id}/convert`);
export const getInvoices      = ()           => api.get('/invoices');
export const createInvoice    = (data)       => api.post('/invoices/generate', data);
export const markInvoicePaid  = (id)         => api.put(`/invoices/${id}/paid`);
export const sendInvoice      = (id)         => api.post(`/invoices/${id}/send`);
export const getLogs          = (params)     => api.get('/logs', { params });
export const monitorComp      = (data)       => api.post('/competitors/monitor', data);
export const getCompReports   = ()           => api.get('/competitors/reports');
export const generateCopy     = (data)       => api.post('/adcopy/generate', data);
export const abTestCopy       = (data)       => api.post('/adcopy/ab-test', data);
export const analyzeCopy      = (data)       => api.post('/adcopy/analyze', data);

// Auth API
export const getUsers         = (params)     => api.get('/auth/users', { params });
export const blockUser        = (uid, reason)=> api.put(`/auth/users/${uid}/block`, { reason });
export const unblockUser      = (uid)        => api.put(`/auth/users/${uid}/unblock`);
export const changeRole       = (uid, role)  => api.put(`/auth/users/${uid}/role`, { role });
export const assignClient     = (uid, clientId) => api.put(`/auth/users/${uid}/assign-client`, { clientId });

// Client Panel API
export const getPanelDashboard = ()          => api.get('/panel/dashboard');
export const getPanelCampaigns = (preset)    => api.get(`/panel/campaigns?date_preset=${preset}`);
export const getPanelSpending  = (preset)    => api.get(`/panel/spending?date_preset=${preset}`);
export const getPanelInvoices  = ()          => api.get('/panel/invoices');
export const getPanelInvoice   = (id)        => api.get(`/panel/invoices/${id}`);

export default api;
